import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import LicenseSearch from './Search/LicenseSearch'
import License from './LicenseManager'
import { Match } from 'types'

type LicenseRouterProps = {
  match: Match
}

const LicenseRouter: React.FC<LicenseRouterProps> = ({ match }) => {
  return (
    <ErrorBoundary>
      <Switch>
        <Route component={License} path={`${match.path}/:id`} />
        <Route component={LicenseSearch} path={match.path} />
      </Switch>
    </ErrorBoundary>
  )
}

export default LicenseRouter
